const e = {
  name: "Experiments",
  dimensions: { width: 24, height: 24 },
  content: `
<svg fill="currentColor">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.99995 2C6.44767 2 5.99995 2.44772 5.99995 3C5.99995 3.55228 6.44767 4 6.99995 4H7.49995V11.2314L3.87256 17.4969C2.71467 19.4969 4.15785 22 6.46884 22H17.5311C19.8421 22 21.2852 19.4969 20.1273 17.4969L16.5 11.2314V4H17C17.5522 4 18 3.55228 18 3C18 2.44772 17.5522 2 17 2H6.99995ZM9.49995 11.5V4H14.5V11.5C14.5 11.6759 14.5464 11.8488 14.6345 12.001L15.7918 14H8.20808L9.36538 12.001C9.45353 11.8488 9.49995 11.6759 9.49995 11.5ZM7.05019 16L5.60342 18.499C5.21745 19.1656 5.69851 20 6.46884 20H17.5311C18.3014 20 18.7824 19.1656 18.3965 18.499L16.9497 16H7.05019Z" />
</svg>
  `
};
export {
  e as Experiments
};
